import KPI_CARDS_MOCK_DATA from '../../../mock-data/kpiCardsMockData';

const kpiCardsData = KPI_CARDS_MOCK_DATA;

export default kpiCardsData;
